(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aroi-faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.querySelector('.aroi-faq-section');
  if (!section) return;

  var tabs = section.querySelectorAll('.aroi-faq-tab');
  var items = section.querySelectorAll('.aroi-faq-item');
  var groups = section.querySelectorAll('.aroi-faq-group');
  var searchInput = section.querySelector('#aroiFaqSearch');
  var noResults = section.querySelector('#aroiFaqNoResults');
  var activeCat = 'all';

  /* Accordion */
  section.querySelectorAll('.aroi-faq-q').forEach(function(q) {
    q.addEventListener('click', function() {
      var item = q.parentElement;
      var wasOpen = item.classList.contains('open');
      section.querySelectorAll('.aroi-faq-item.open').forEach(function(i) {
        i.classList.remove('open');
      });
      if (!wasOpen) item.classList.add('open');
    });
  });

  /* Tabs */
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      tabs.forEach(function(t) { t.classList.remove('aroi-faq-tab--active'); });
      tab.classList.add('aroi-faq-tab--active');
      activeCat = tab.dataset.cat;
      applyFilter();
    });
  });

  /* Search */
  if (searchInput) {
    searchInput.addEventListener('input', applyFilter);
  }

  function applyFilter() {
    var q = searchInput ? searchInput.value.trim().toLowerCase() : '';
    var total = 0;

    items.forEach(function(item) {
      var cat = item.dataset.cat;
      var text = (item.querySelector('.aroi-faq-q').textContent + item.querySelector('.aroi-faq-a').textContent).toLowerCase();
      var catOk = activeCat === 'all' || cat === activeCat;
      var qOk = !q || text.indexOf(q) !== -1;
      var show = catOk && qOk;
      item.hidden = !show;
      if (show) total++;
    });

    groups.forEach(function(g) {
      var gCat = g.dataset.group;
      var catMatch = activeCat === 'all' || gCat === activeCat;
      var hasVisible = Array.prototype.slice.call(g.querySelectorAll('.aroi-faq-item')).some(function(i) { return !i.hidden; });
      g.style.display = (catMatch && hasVisible) ? '' : 'none';
    });

    if (noResults) {
      noResults.style.display = total === 0 ? 'block' : 'none';
    }
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
